import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from 'tss-react/mui';
import { fromJS } from 'immutable';
import Grid from '@mui/material/Grid';
import { C_COMPTA } from '@lba-dev/package.local-globals/commentTypes';

import Comments from '../../Comments';
import PaymentTable from './PaymentTable';
import { setDialogContentProp } from '../../../actions/dialog';

const setComments = setDialogContentProp('comments');

const styles = {
  div: {
    width: '100%'
  },
};

const mapStateToProps = ({
  dialog: {
    contentProps: { id, _id, intervention },
  },
  users,
  connectedUser,
}) => ({
  comments: intervention.comments || [],
  intervention,
  id,
  _id,
  users,
  user: connectedUser,
});
const mapDispatchToProps = {
  setComments,
};

const PaymentAnnexesDialog = ({
  classes,
  users,
  user,
  comments,
  setComments,
  intervention
}) => (
  <div className={classes.div}>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <PaymentTable
          intervention={intervention}
          userId={user._id}
          users={users}
          user={user}
        />
      </Grid>
      <Grid key={1} item xs={12} >
        <Comments
          id={intervention.id}
          interId={intervention._id}
          users={users}
          user={user}
          userId={user._id}
          comments={fromJS(comments)}
          type={C_COMPTA}
          setData={(p, v) => setComments(v)}
        />
      </Grid>
    </Grid>
  </div>
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(PaymentAnnexesDialog, styles));
